import { useTranslation } from 'react-i18next';

import { useIsPlatformAdmin } from '@/hooks/use-is-platform-admin';

/** Explains to platform managers why a settings page has no save action. */
export const ReadOnlyNotice = ({ message }: { message?: string }) => {
  const { t } = useTranslation('admin');
  const isAdmin = useIsPlatformAdmin();
  if (isAdmin) return null;
  return (
    <p className="mb-6 text-body-sm text-fg-secondary">{message ?? t('readOnly.settings')}</p>
  );
};
